import { getIt } from "@uikit/getIt";
import { HomePluginStore } from "imagica-corekit/dist/base/store/HomePluginStore";
import { useStore as useImagicaStore } from "imagica-uikit/dist/hooks/useStore";
import { useCallback, useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { CreatorRoot } from "../ProjectCanvas/CreatorRoot";
import { PageNavBar } from "./PageNavBar";
import { ProjectPage } from "./ProjectPage";
import { SharePage } from "./SharePage";
import style from "./homeroot.module.scss";

import { useContainerMounted } from "@custom-hooks/HomeUsePluginRoot/useContainerMounted";
import useCreateNewProject from "@custom-hooks/useCreateNewProject";
import store, { RootState } from "@store/index";
import { useHomePlugin } from "@views/thinking-layout-editor/HomeUsePluginV2";
import { ProjectStore } from "imagica-corekit/dist/base/store/ProjectStore";
import { useDispatch, useSelector } from "react-redux";
import { GuideContainer } from "../Guide";
import { CreatorCustomAPIFunction } from "../ProjectCanvas/CreatorRoot/CreatorCustomAPIFunction";
import { CreatorCustomJSFunction } from "../ProjectCanvas/CreatorRoot/CreatorCustomJSFunction";

import { MultiRoundChatOnboarding } from "@uiview/views/MultiRoundChatOnboarding/MultiRoundChatOnboarding";
import classNames from "classnames";
import { creatorRefStore } from "../ProjectCanvas/store/CreatorRefStore";
import creatorCss from "./CreatorRoot.module.scss";
import { showNavPageStore } from "./store/ShowNavPageStore";

import { usePreviewAppStore } from "@custom-hooks/HomeUsePluginRoot/usePreviewAppStore";
import { studioActions } from "@store/studio";
import func, { matchMobile } from "@uikit/func";
import { CanvasDataRef } from "@uikit/model/CanvasDataRef";
import { HomeMethodsService } from "@uikit/service/HomeMethodsService";
import { previewStore } from "@uiview/store/PreviewStore";
import { CreatorEdgesStore } from "@uiview/views/ProjectCanvas/store/CreatorEdgesStore";
import { ViewBuilderGraph } from "imagica-corekit/dist/base/api/viewBuilderTyped/viewBuilderGraph";
import { eventbus } from "imagica-corekit/dist/base/cutil/Eventbus";
import { CotMsg } from "imagica-corekit/dist/base/msg/CotMsg";
import { ChatOnboardingState, ChatOnboardingStore } from "imagica-corekit/dist/cases/chatOnboarding/ChatOnboarding";
import { GenUIProcess, TalkBuilder } from "imagica-corekit/dist/cases/chatOnboarding/ChatOnboardingType";
import { CotFlow } from "imagica-corekit/dist/cases/cot/CotFlow";
import { HomeUtil } from "imagica-corekit/dist/cases/home/HomeUtil";
import { HomeStore } from "imagica-corekit/dist/cases/store/HomeStore";
import { ViewbuilderStore } from "imagica-corekit/dist/cases/store/ViewbuilderStore";
import { ViewBuilder } from "imagica-corekit/dist/cases/viewBuilder/ViewBuilder";
import { GetItContext } from "imagica-uikit/dist/base/provider/GetItContext";
import { forEach, uniqBy } from "lodash";
import HomeMobile from "../Mobile/HomeMobile";
import { getDefaultPreviewAppTypeList } from "../PreviewApp/const";
import { PreviewInput } from "../PreviewApp/model/previewInput";
import { PreviewPaneStore, SettingPageContentType } from "../PreviewPane/PreviewPaneStore";
import { CreatorPreviewPanel } from "../ProjectCanvas/CreatorRoot/CreatorPreviewPanel";
import { CreatorAISaasStore } from "../ProjectCanvas/store/CreatorAISassStore";
import { creatorCotStore } from "../ProjectCanvas/store/CreatorCotStore";
import { CreatorNodesStore } from "../ProjectCanvas/store/CreatorNodesStore";
import { CreatorSaasAppStore } from "../ProjectCanvas/store/CreatorSaasAppStore";
import { projectRunStore } from "../ProjectCanvas/store/ProjectRunStore";
import { useHomeHandleFieldMethods } from "../ProjectCanvas/useHomeHandleFieldMethods";
import { useHomePreviewMethods } from "../ProjectCanvas/useHomePreviewMethods";
import { PreviewAppStore } from "../ProjectCanvas/store/PreviewAppStore";
import { ProjectNodeStore } from "@uikit/projectNode/ProjectNodeStore";

export function HomeRoot(): React.JSX.Element {
  const isMobile = matchMobile();
  const projectStore = getIt(ProjectStore);
  const creatorAISassStore = getIt(CreatorAISaasStore);
  const homePluginStore = getIt(HomePluginStore);
  const creatorSaasAppStore = getIt(CreatorSaasAppStore);
  const homeMethods = getIt(HomeMethodsService);
  const chatOnboardingStore = getIt(ChatOnboardingStore);
  const canvasDataRef = getIt(CanvasDataRef);
  const creatorNodesStore = getIt(CreatorNodesStore);
  const creatorEdgesStore = getIt(CreatorEdgesStore);
  const previewPaneStore = getIt(PreviewPaneStore);
  const viewbuilderStore = getIt(ViewbuilderStore);
  const projectNodeStore = getIt(ProjectNodeStore);

  const chatOnboardingState = useImagicaStore(chatOnboardingStore).value;
  const viewbuilderState = useImagicaStore(viewbuilderStore).value;
  const creatorCotState = useImagicaStore(creatorCotStore).value;
  const location = useLocation();

  const creatorSaasAppState = useImagicaStore(creatorSaasAppStore).value;
  const { saasUIData } = creatorSaasAppState;

  useContainerMounted();

  const dispatch = useDispatch();

  // TODO: 挪动selectedTemplate
  const selectedTemplate: any = useSelector((state: RootState) => state.studio.selectedTemplate);
  const setSelectedTemplate = (val: any): void => {
    dispatch(studioActions.setSelectedTemplate(val));
  };

  const homeStore = getIt(HomeStore);
  const cotFlow = getIt(CotFlow);
  const featureTags = homeStore.state.featureTags;
  const homePlugin = useHomePlugin();
  const homeHandleFieldMethods = useHomeHandleFieldMethods();
  const homePreviewMethods = useHomePreviewMethods();
  const previewAppStoreHook = usePreviewAppStore();
  const previewAppStore = getIt(PreviewAppStore);

  const originalTemplate = store.getState().studio.selectedTemplate as any;
  const showNavPageState = useImagicaStore(showNavPageStore).value;
  const previewState = useImagicaStore(previewStore).value;

  const openPreviewPage = useCallback(() => {
    //  previewApp未打开时，打开previewPane，并创建一个prevewApp
    previewAppStore.openPreviewPage();
    previewPaneStore.setMobileChatStatus(false);
    //  build过则不再重新创建previewApp
    if (chatOnboardingStore.state.currentStep !== GenUIProcess.Build) {
      previewAppStore.clearPreviewApp();
      previewAppStoreHook.addPreview({ format: getDefaultPreviewAppTypeList()[0] });
    }
    // eslint-disable-next-line
  }, []);

  //  如果新生成的input和output不包含talkToBuilder中数据，则清空talkToBuilder
  const clearTalkToBuilder = (nodes: any): void => {
    const hasNode = nodes.some((item: any) => item.data?.inputTitle === chatOnboardingStore.state.talkBuilder.content);
    if (!hasNode) {
      chatOnboardingStore.setChatOnboardingState({ talkBuilder: new TalkBuilder() });
    }
  };

  const generateViewBuilder = (viewBuilderGraph: ViewBuilderGraph): void => {
    const inputs: PreviewInput[] = [];
    forEach(viewBuilderGraph.user_inputs, (input, index) => {
      const previewInput = new PreviewInput();
      previewInput.id = `viewBuilderInput-${index}`;
      previewInput.data.placeholder = input.description || "";
      // stud-2493 set input title(preview)
      previewInput.data.inputTitle = input.name || "";
      // stud-2493 set generated label(preview)
      previewInput.data.generatedLabel = input.name || "";
      previewInput.data.textAreaValue = input.value || "";
      previewInput.data.viewbuilderGraphUserInputId = input.id || "";
      inputs.push(previewInput);
    });
    if (viewBuilderGraph.graph && viewBuilderGraph.graph?.nodes?.length) {
      const flow = ViewBuilder.transformGraph(
        viewBuilderGraph.graph,
        homePlugin.nodeDataRef.current,
        getIt(CanvasDataRef).newEdgeDataRef.current,
        homePlugin.newLineDataRef.current
      );

      creatorNodesStore.setNodes(flow.nodes || []);
      creatorEdgesStore.setEdges(flow.edges || []);
    }

    const title = originalTemplate.isMannulModifyProjectName
      ? originalTemplate.name
      : creatorSaasAppStore.state.saasUIData.appDetail?.name;
    const subTitle = creatorSaasAppStore.state.saasUIData.appDetail?.description;

    setSelectedTemplate({
      ...store.getState().studio.selectedTemplate,
      name: title,
      template_name: title,
    });
    // stud-2493 set input(preview)
    creatorSaasAppStore.setSaasUIData((prevData: any) => {
      return {
        ...prevData,
        output: [],
        input: inputs,
        viewBuilderGraph: viewBuilderGraph,
        title,
        subTitle,
      };
    });
    projectNodeStore.composeNodes(creatorNodesStore.getNodes(), creatorSaasAppStore.state.saasUIData);
  };

  const genUIStartFlow = useCallback(
    async ({ flow, platform = "saas" }: { flow: any; platform?: string }) => {
      projectRunStore.setRunAllLoading(false);
      const flowData = await cotFlow.transformTemplate(
        "",
        flow,
        homePlugin.nodeDataRef.current,
        canvasDataRef.newEdgeDataRef.current,
        canvasDataRef.newLineDataRef.current
      );
      const { nodes = [], edges = [], inputs = [], previewData } = flowData || {};
      creatorNodesStore.setNodes(nodes);
      creatorEdgesStore.setEdges(edges);
      homePlugin.defaultOpenWebApp();

      const title = originalTemplate.isMannulModifyProjectName
        ? originalTemplate.name
        : creatorSaasAppStore.state.saasUIData.appDetail?.name;
      const subTitle = creatorSaasAppStore.state.saasUIData.appDetail?.description;
      // FIXME: do we need to use generated app title as project name on thinking canvas too?
      setSelectedTemplate({
        ...store.getState().studio.selectedTemplate,
        name: title,
        template_name: title,
      });
      // stud-2493 set input(preview)(clear)
      // fitCanvas();
      // Empty input and output first
      creatorSaasAppStore.setSaasUIData((prevData: any) => {
        return {
          ...prevData,
          output: [],
          input: [],
        };
      });
      projectNodeStore.composeNodes(creatorNodesStore.getNodes(), creatorSaasAppStore.state.saasUIData);

      if (previewData) {
        const { input = [], output = [] } = previewData;
        const uniqNodes = uniqBy(nodes, node => node.id);
        const inputNodes = uniqNodes.filter(node => input.map(item => `editor-${item}`).includes(node.id));
        const outPutNodes = uniqNodes.filter(node => output.map(item => `editor-${item}`).includes(node.id));
        const outPutGroupNodes = uniqNodes.filter(node => output.map(item => `group-${item}`).includes(node.id));
        const inputIds = store.getState().fot.inputId;
        const addInputs = inputs.map(x => x.id);
        const newInputId = [...inputIds, ...addInputs];
        creatorAISassStore.setInputId(newInputId);
        clearTalkToBuilder([...inputNodes, ...outPutNodes]);
        const needAddInput = inputNodes.filter(node =>
          (creatorSaasAppStore.state.saasUIData.input || []).every((input: any) => input.id !== node.id)
        );
        needAddInput.forEach(input => {
          homeHandleFieldMethods.handleInputField(
            input,
            platform,
            creatorRefStore.cotDescription.current,
            title,
            subTitle
          );
        });
        outPutNodes.forEach(node => homePreviewMethods.addIndividual(node, platform, true));
        outPutGroupNodes.forEach(node => homePreviewMethods.clickGroupToPreview(node, platform, true));
      }
      creatorSaasAppStore.setSaasUIData((prevData: any) => {
        return {
          ...prevData,
          title,
          subTitle,
        };
      });
      eventbus.emit(new CotMsg());
    },
    // eslint-disable-next-line
    [homePlugin.nodeDataRef]
  );

  const { addNewProject } = useCreateNewProject({
    emptyNodes: homeMethods.emptyNodes,
  });

  // shownavpage effect
  useEffect(() => {
    if (homePluginStore.state.isShare) {
      return;
    }
    const template = store.getState().studio.selectedTemplate as any;
    const attrIndexer = showNavPageState.showNavPage ? "" : HomeUtil.getAttrIndexerByTemplateProject(template);
    projectStore.setAttrIndexer(attrIndexer);
    // eslint-disable-next-line
  }, [showNavPageState.showNavPage, selectedTemplate]);

  // static effect
  const isStaticMode = useSelector((state: RootState) => state.editor.isStaticMode);
  useEffect(() => {
    creatorSaasAppStore.setSaasUIData(prevData => ({
      ...prevData,
      staticMode: isStaticMode,
    }));
    // eslint-disable-next-line
  }, [isStaticMode]);

  useEffect(() => {
    if (homePluginStore.state.isShare) {
      return;
    }

    const defalutTitle = "Imagica A new way to think and create with computers | Build a no-code AI app in minutes";

    if (!func.isEmpty(selectedTemplate) && !func.isEmpty(selectedTemplate?.name)) {
      document.title = selectedTemplate.name;
    } else {
      document.title = defalutTitle;
    }
  }, [selectedTemplate]);

  useEffect(() => {
    // 回到首页时
    if (location.pathname === "/editor" && showNavPageState.showNavPage) {
      resetDataWhenBackToHome();
    }
    // eslint-disable-next-line
  }, [location.pathname, showNavPageState.showNavPage]);

  useEffect(() => {
    if (viewbuilderState.viewBuilderGraph) {
      creatorSaasAppStore.setSaasUIData((prevData: any) => {
        return {
          ...prevData,
          viewBuilderGraph: viewbuilderState.viewBuilderGraph,
        };
      });
    }
    // eslint-disable-next-line
  }, [viewbuilderState.viewBuilderGraph]);

  /**
   * 回到首页需要清空一些数据
   */
  const resetDataWhenBackToHome = (): void => {
    chatOnboardingStore.setState(new ChatOnboardingState());
    homePluginStore.setInitWithCot(false);
    previewStore.setPreviewCollapseState(false);
    previewPaneStore.setSettingPageContentType(SettingPageContentType.none);
  };

  const RenderMultiRoundChatOnboarding = useMemo(() => {
    if (
      featureTags.disableMultiRoundChatOnboarding === false &&
      showNavPageState.showNavPage === false &&
      (creatorCotState.showMultiRoundChatOnboarding || chatOnboardingState.isOpenChat)
    ) {
      return (
        <MultiRoundChatOnboarding
          generateViewBuilder={generateViewBuilder}
          showFlow={genUIStartFlow}
          showPreview={openPreviewPage}
          setSaasUIData={creatorSaasAppStore.setSaasUIData}
          saasUIData={saasUIData}
        />
      );
    }
    return null;
  }, [
    featureTags.disableMultiRoundChatOnboarding,
    showNavPageState.showNavPage,
    creatorCotState.showMultiRoundChatOnboarding,
    chatOnboardingState.isOpenChat,
    chatOnboardingState.selectTemplateInModal,
    genUIStartFlow,
    openPreviewPage,
    previewState.showPreviewPanel,
  ]);

  // render
  if (homePluginStore.state.isShare) {
    return (
      <GetItContext.Provider value={getIt}>
        <SharePage />;
      </GetItContext.Provider>
    );
  }

  //  移动端
  if (isMobile && featureTags.disableMobilePage) {
    return (
      <HomeMobile
        addNewProject={addNewProject}
        generateViewBuilder={generateViewBuilder}
        genUIStartFlow={genUIStartFlow}
        openPreviewPage={openPreviewPage}
        setSaasUIData={creatorSaasAppStore.setSaasUIData}
        saasUIData={saasUIData}
      />
    );
  }

  // FIXME: 当 multi 显示的时候，应不渲染 canvas 相关组件
  return (
    <div
      className={classNames(style["home-plugin"], creatorCss["creatorRoot"])}
      ref={creatorRefStore.homeRef}
      id="HomeRoot"
      data-testid="HomeRoot"
    >
      <PageNavBar addNewProject={addNewProject} />

      {showNavPageState.showNavPage ? <ProjectPage addNewProject={addNewProject} /> : <CreatorRoot />}

      <CreatorCustomJSFunction />

      <CreatorCustomAPIFunction />

      {showNavPageState.showNavPage === false && (
        <GetItContext.Provider value={getIt}>
          <CreatorPreviewPanel />
        </GetItContext.Provider>
      )}

      <GuideContainer addNewProject={addNewProject} />

      {RenderMultiRoundChatOnboarding}
    </div>
  );
}
